import React from 'react'
import { FieldArray } from 'formik';
import {
  Box,
  Button,
  Divider,
  Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import RsltCostForm from './RsltCostForm';


const TechProductListForm = ({ formik, fieldName = 'rsltCosts', readOnly = false }) => {

  const costList = formik.values?.[fieldName] ?? [];
  const totalPrice = costList.reduce((sum, cost) => {
    if (cost?.costVal === '' || cost?.costVal === null || typeof cost?.costVal === 'undefined' || isNaN(cost.costVal)) {
      return sum;
    }

    return sum + parseInt(cost.costVal, 10);
  }, 0);



  return (
    <div>
      <FieldArray
        name={fieldName}
        render={arrayHelpers => (
          <Box>
            {costList.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography variant="subtitle2" component="div">{readOnly ? '작업기록 실비가 없습니다.' : '소요비용이 없습니다.'}</Typography>
              </Box>

            ) : (
              <TableContainer component={Box}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>종류</TableCell>
                      <TableCell>비용</TableCell>
                      <TableCell>비고</TableCell>
                      <TableCell>{readOnly ? '' : '삭제'}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {costList.map((c, index) => {

                      return (
                        <RsltCostForm
                          key={index}
                          index={index}
                          formik={formik}
                          fieldName={fieldName}
                          readOnly={readOnly}
                          handleRemove={() => arrayHelpers.remove(index)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
              <Box>
                <Typography variant="subtitle2" component="div" sx={{ mr: 2 }}>총 가격:₩{totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
              </Box>
              {!readOnly && (
                <Box>
                  <Button color="secondary" variant="outlined" onClick={() => arrayHelpers.push({
                    costTyp: '',
                    costVal: '',
                    costDesc: '',
                  })}>비용 추가
                  </Button>
                </Box>
              )}
            </Box>
            <Divider sx={{ my: 1 }} />
          </Box>

        )}

      >

      </FieldArray>

    </div>
  )
}



export default TechProductListForm
